module.exports = __webpack_public_path__ + "media/images/chat_preview_portrait-13f3600e182a7d47e6e1d0e92759dd4d.png";